export default state => {
  if (!state || !state.job || !state.job.list || !Array.isArray(state.job.list.items)) {
    return undefined;
  }

  const activeJob = state.job.list.items.find(item => item.isActive);

  return activeJob;
};
